var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"to":`/${_vm.$i18n.locale}/register`,"text":""}},[_vm._v(" "+_vm._s(_vm.$t("appbar.signup"))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }